import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/banner-hol.jpg'
import _imports_1 from '../assets/banner.png'
import _imports_2 from '../assets/hot.png'
import _imports_3 from '../assets/path.png'
import _imports_4 from '../assets/icon.png'


const _withScopeId = n => (_pushScopeId("data-v-53e22810"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "homeBar" }, "境外上网", -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  style: {"width":"100%","border-radius":"0.2rem"},
  alt: ""
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  class: "banner",
  style: {"width":"100%"},
  alt: ""
}
const _hoisted_7 = { class: "hotGood" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"0.32rem"},
    src: _imports_2,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" 热门商品 ")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createTextVNode(" 全部 "),
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"0.4rem"},
    src: _imports_3,
    alt: ""
  })
], -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "hotCard" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "title" }
const _hoisted_14 = { class: "cardContent" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subheading" }, null, -1))
const _hoisted_16 = { class: "other" }
const _hoisted_17 = { class: "price" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"0.24rem"} }, "￥", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn" }, "抢购", -1))
const _hoisted_20 = { class: "hotDestination" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"0.32rem"},
    src: _imports_4,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" 热门目的地 ")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createTextVNode(" 全部 "),
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"0.4rem"},
    src: _imports_3,
    alt: ""
  })
], -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "cityCard" }
const _hoisted_25 = ["src", "onClick"]
const _hoisted_26 = {
  key: 1,
  style: {"background-color":"#fff","padding":"0 0.16rem 0.16rem"}
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "onlyBeijing" }, "仅限北京移动用户办理", -1))
const _hoisted_28 = { class: "left" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"0.32rem"},
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_30 = { class: "llbFlex" }
const _hoisted_31 = ["src", "onClick"]

import { request } from "@/provide/fetch";
import router from "@/router";
import { NavBar, Search, Toast, Tabs, Tab, Sidebar, SidebarItem } from "vant";
import { ydList } from "@/utils/constants";
import { ref } from "vue";
import type { Product, ProductResponse } from "@/types/product";


export default /*#__PURE__*/_defineComponent({
  name: 'HomePage',
  setup(__props) {

const hotCard = ref<Product[]>([]);
const tabList = ref([
  {
    name: "境外电话卡",
  },
  {
    name: "境外流量包",
  },
]);
const activeType = ref("境外电话卡");
const operatorList = ref(["移动"]);
const operatorActive = ref("移动");
// 是否节假日
const isHoliday = ref(new Date() < new Date("2025-02-06"));
const channel =
  window.location.hostname === "international-card-tc.mobilecn.net"
    ? "aBrTdjlLMn"
    : "paCDWXhjKM";
request({
  url: `/product/get-product-list?country_name=&channel=${channel}`,
  // method: "POST",
})
  .then((res) => {
    if (res.code == 200) {
      hotCard.value = res.data;
    } else {
      Toast(res.message);
    }
  })
  .catch(() => {
    Toast("网络错误，请稍后重试");
  });
const cityLList = ref([
  {
    name: "日本",
    img: require("../assets/rb.png"),
  },
  {
    name: "韩国",
    img: require("../assets/hg.png"),
  },
  {
    name: "新加坡",
    img: require("../assets/xjp.png"),
  },
  {
    name: "马来西亚",
    img: require("../assets/mlxy.png"),
  },
  {
    name: "泰国",
    img: require("../assets/tg.png"),
  },
  {
    name: "印度尼西亚",
    img: require("../assets/ydnxy.png"),
  },
  {
    name: "越南",
    img: require("../assets/yn.png"),
  },
  {
    name: "菲律宾",
    img: require("../assets/flb.png"),
  },
  {
    // 欧洲多国
    name: "英国",
    img: require("../assets/ozdg.png"),
  },
  {
    name: "美国",
    img: require("../assets/mg.png"),
  },
  {
    name: "澳大利亚",
    img: require("../assets/adly.png"),
  },
  {
    name: "新西兰",
    img: require("../assets/xxl.png"),
  },
  // {
  //   name: "加拿大",
  //   img: require("../assets/jnd.png"),
  // },
  {
    name: "中国香港",
    img: require("../assets/xg.png"),
  },
  {
    name: "中国澳门",
    img: require("../assets/am.png"),
  },
  {
    name: "中国台湾",
    img: require("../assets/tw.png"),
  },
  // {
  //   name: "阿联酋",
  //   img: require("../assets/alq.png"),
  // },
]);

const value = ref("");
const handleClick = (item: any) => {
  location.href = item.href;
};

const handleTabClick = (name: string) => {
  if (name === "联通") {
    window.location.href = "https://flow.wo.cn/s1m1H5/";
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_unref(Search), {
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        shape: "round",
        background: "#386BF6",
        placeholder: "搜索目的地",
        readonly: "",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/Search')))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (activeType.value == '境外电话卡')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (isHoliday.value)
              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
              : (_openBlock(), _createElementBlock("img", _hoisted_6)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: "cardHeader",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/hotGoods')))
              }, _hoisted_10),
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hotCard.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    onClick: ($event: any) => (_unref(router).push(`/hotGoodsDetails/${item.id}`)),
                    class: "cardItem"
                  }, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(item.productName), 1),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createTextVNode(_toDisplayString(item.productFloorPrice), 1)
                        ]),
                        _hoisted_19
                      ])
                    ])
                  ], 8, _hoisted_12))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", {
                class: "cardHeader",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push('/Search')))
              }, _hoisted_23),
              _createElementVNode("div", _hoisted_24, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cityLList.value, (item) => {
                  return (_openBlock(), _createElementBlock("img", {
                    key: item.img,
                    src: item.img,
                    alt: "",
                    onClick: ($event: any) => (
                _unref(router).push({
                  name: 'hotGoods',
                  query: {
                    name: item.name,
                  },
                })
              )
                  }, null, 8, _hoisted_25))
                }), 128))
              ])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _hoisted_27,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ydList), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                style: {"padding-top":"0.16rem"}
              }, [
                _createElementVNode("div", {
                  class: "cardHeader",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push('/hotGoods')))
                }, [
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createTextVNode(" " + _toDisplayString(item.name), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.dataList, (llkItem) => {
                    return (_openBlock(), _createElementBlock("img", {
                      key: llkItem.img,
                      src: llkItem.img,
                      onClick: ($event: any) => (handleClick(llkItem)),
                      alt: ""
                    }, null, 8, _hoisted_31))
                  }), 128))
                ])
              ]))
            }), 128))
          ]))
    ])
  ]))
}
}

})